// extracted by css-extract-rspack-plugin
export default {"cls1":"Loading-cls1_LVj","cls2":"Loading-cls2_X8a Loading-cls1_LVj","short":"Loading-short_YO_","long":"Loading-long_JG8"};